// extracted by mini-css-extract-plugin
export default {"googleMapIframe":"_1Bf_o___EmbeddedMap-module__googleMapIframe","iframeContainer":"_2nFIb___EmbeddedMap-module__iframeContainer"};